export default [
  {
    key: 'checkbox',
    label: '',
    sortable: false,
    class: 'align-middle',
    show: true,
    type: 'checkbox',

  },
  {
    key: 'publisher_name',
    label: 'publisher',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
  },

  {
    key: 'top_inventory_name',
    label: 'Top Inventory name',
    sortable: true,
    class: 'text-center align-middle',
    show: false,
  },

  {
    key: 'billing_source',
    label: 'Billing source',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
  },
  {
    key: 'impressions',
    label: 'Month impressions',
    sortable: true,
    show: true,
    class: 'text-center align-middle',
  },
  {
    key: 'read_reconciliated_impressions',
    label: 'Reconciled Impressions',
    sortable: true,
    show: true,
    class: 'text-center align-middle',
  },
  {
    key: 'impressions_discrepancy',
    label: 'Discrepancy',
    sortable: false,
    show: true,
    class: 'text-center align-middle',
  },
  {
    key: 'cost_rate',
    label: 'eCPM',
    sortable: true,
    class: 'text-center align-middle',
    show: false,
  },
  {
    key: 'base_rate',
    label: 'Rate',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
  },
  {
    key: 'cost_total',
    label: 'Total Cost',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
  },
  {
    key: 'top_inventory_id',
    label: '',
    sortable: true,
    class: 'text-center align-middle',
    show: false,
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    show: true,
    class: 'text-center align-middle',
  },
  {
    key: 'action',
    label: 'Action',
    sortable: false,
    show: true,
    type: 'actions',
    class: 'text-center align-middle',
  },
]
